var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1012(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 14.7092C11.866 14.7092 15 11.5752 15 7.70923C15 3.84324 11.866 0.709229 8 0.709229C4.13401 0.709229 1 3.84324 1 7.70923C1 11.5752 4.13401 14.7092 8 14.7092Z",
    fill: "#753CBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.7092C11.866 14.7092 15 11.5752 15 7.70923C15 3.84324 11.866 0.709229 8 0.709229C4.13401 0.709229 1 3.84324 1 7.70923C1 11.5752 4.13401 14.7092 8 14.7092Z",
    fill: "white",
    stroke: "#753CBE",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26114 7.70932C8.26126 7.65759 8.24604 7.60699 8.21739 7.56391C8.18874 7.52084 8.14795 7.48723 8.10019 7.46735C8.05243 7.44746 7.99985 7.4422 7.94909 7.45221C7.89834 7.46223 7.8517 7.48708 7.81507 7.52361C7.77845 7.56015 7.75349 7.60673 7.74335 7.65746C7.73321 7.70819 7.73835 7.76079 7.75812 7.80859C7.77789 7.8564 7.8114 7.89727 7.8544 7.92602C7.89741 7.95478 7.94798 7.97012 7.99971 7.97012C8.06894 7.97012 8.13534 7.94267 8.18435 7.89378C8.23335 7.84488 8.26097 7.77855 8.26114 7.70932V7.70932Z",
    fill: "#753CBE",
    stroke: "#753CBE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00488 1.83545V2.7073",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00488 12.6431V13.5149",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8446 7.67554H12.9722",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03738 7.67554H2.16553",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0672 2.70288L10.6099 3.44559",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39973 11.905L4.94238 12.6477",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1423 4.89893L12.375 5.31343",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63447 10.0369L2.86719 10.4514",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9771 10.738L12.2344 10.28",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77543 5.07014L3.03271 4.61279",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 12.8131L10.3667 12.0452",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64302 3.30537L5.22852 2.53809",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14476 1.20905C6.72138 1.16264 5.32216 1.58499 4.16216 2.41116C3.00217 3.23733 2.92171 2.84889 2.50024 4.20923L7.93297 7.70559L8.14476 1.20905Z",
    fill: "#753CBE",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1012);
export default __webpack_public_path__ + "static/media/10_12.6d6bcf7a440ae3f01cc190ad50c33578.svg";
export { ForwardRef as ReactComponent };